import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import AuthModal from '../../components/AuthModal';
import PromotionFullWidthSlider from '../../components/promotions/PromotionFullWidthSlider';
import CategorySlider from '../../components/categories/CategorySlider';
import FeatureSection from '../../components/features/FeatureSection';
import PromotionChatSection from '../../components/promotions/PromotionChat';
import CompanyLogosSlider from '../../components/companies/CompanyLogosSlider';
import Footer from '../../components/layout/Footer';

const LandingPage: React.FC = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [redirectToChat, setRedirectToChat] = useState(false);
  const navigate = useNavigate();

  // Función para manejar el clic en el botón "Ingresa al panel de solicitudes"
  const handleRequestPanelClick = () => {
    const authToken = localStorage.getItem('auth_token');

    if (authToken) navigate('/chat');
    else {
      setRedirectToChat(true);
      setShowAuthModal(true);
    }
  };

  // Función para manejar el cierre del modal de autenticación
  const handleAuthModalClose = () => {
    setShowAuthModal(false);
  };

  // Función para manejar la autenticación exitosa
  const handleAuthSuccess = () => {
    // Cerrar el modal
    setShowAuthModal(false);

    // Si la bandera redirectToChat está activa, redirigir a ChatPage
    if (redirectToChat) {
      navigate('/chat');
    }
  };
  return (
    <div>
      <div className="min-h-screen px-2 md:px-32 bg-xervix-bg-primary text-xervix-text-primary dark:bg-xervix-bg-primary-dark dark:text-xervix-text-primary-dark">
        <Navbar />

        {/* Hero Section */}
        <div id="home" className="container mx-auto px-6 md:px-12 py-12 flex flex-col md:flex-row items-center">
          {/* Left side - Text content */}
          <div className="md:w-[65%] w-full">
            <h1 className="text-5xl md:text-[72px] font-bold mb-4 md:mb-6 leading-tight text-xervix-text-primary dark:text-xervix-text-primary-dark">
              Simplifica tu <br />
              vida con <br />
              <span className="text-xervix-primary">XERVIX</span>
            </h1>
            <p className="text-sm md:text-lg mb-4 md:mb-8 md:max-w-[65%] w-full leading-relaxed text-xervix-text-muted dark:text-xervix-text-muted-dark">
              XERVIX conecta a personas con servicios confiables y rápidos,
              facilitando tu día a día con soluciones sencillas y efectivas.
              Encuentra lo que necesitas en un solo lugar, sin complicaciones
            </p>

            {/* Imágenes en mobile - 8 iconos en 2 filas */}
            <div className="md:hidden space-y-2 mb-4">
              {/* Primera fila */}
              <div className="grid grid-cols-4 gap-2">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/electricidad.png')}
                    alt="Electricidad"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/Plomeria.png')}
                    alt="Plomería"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/carpinteria.png')}
                    alt="Carpintería"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-pink-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/limpieza.png')}
                    alt="Limpieza"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>

              {/* Segunda fila */}
              <div className="grid grid-cols-4 gap-2">
                <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/pintura-removebg-preview.png')}
                    alt="Pintura"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-red-50 to-red-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/jardineria.png')}
                    alt="Jardinería"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/mantenimiento.png')}
                    alt="Mantenimiento"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-gray-800 dark:to-gray-700 rounded-lg p-2 flex items-center justify-center">
                  <img
                    src={require('../../assets/images/remodelacion.png')}
                    alt="Remodelación"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={handleRequestPanelClick}
              className="mt-4 md:mt-0 bg-xervix-primary hover:bg-red-500 text-white font-medium py-3 px-2 md:px-8 rounded-md transition-colors duration-300 w-full md:w-fit"
            >
              INGRESA AL PANEL DE SOLICITUDES
            </button>
          </div>

          {/* Right side - Images */}
          <div className="hidden  md:block md:w-[65%] relative">
            <div className="relative">
              {/* Main image - portada.png */}
              <div className="relative z-10">
                <img
                  src={require('../../assets/images/portada.png')}
                  alt="Servicios Xervix"
                  className="w-full h-auto object-contain"
                />
              </div>

            </div>
          </div>
        </div>

        {/* Sección de Categorías de Servicios */}
        <div className="container mx-auto px-4 md:px-12 pt-6 md:pt-10">
          <CategorySlider />
        </div>

        {/* Sección de Características */}
        <div id="que-hacemos">
          <FeatureSection />
        </div>

        {/* Sección de Promociones */}
        <div className="container mx-auto px-4 md:px-12 pt-2 md:pt-10">
          <PromotionFullWidthSlider />
        </div>

        {/* Sección de Logos de Empresas */}
        <CompanyLogosSlider />

        {/* Sección de Chat */}
        <div id="como-funciona">
          <PromotionChatSection />
        </div>

        {/* Modal de autenticación */}
        {showAuthModal && (
          <AuthModal
            isOpen={showAuthModal}
            onClose={handleAuthModalClose}
            onAuthSuccess={handleAuthSuccess}
          />
        )}


      </div>
      {/* Footer */}
      <div id="contacto">
        <Footer />
      </div>
    </div>

  );
};

export default LandingPage;
